import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiQrCode = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M3 11V3H11V11H3ZM5 9H9V5H5V9ZM3 21V13H11V21H3ZM5 19H9V15H5V19ZM13 11V3H21V11H13ZM15 9H19V5H15V9ZM19 21V19H21V21H19ZM13 15V13H15V15H13ZM15 17V15H17V17H15ZM13 19V17H15V19H13ZM15 21V19H17V21H15ZM17 19V17H19V19H17ZM17 15V13H19V15H17ZM19 17V15H21V17H19Z" />
  </SvgWrapper>
);
